/*
  INGEMA · Capa de micro-animaciones con Motion (motion.dev, versión 14, global `Motion`).
  Complementa a ingema-motion.js (GSAP), que sigue manejando portada, terrenos, díptico y escena.
  Aquí va lo que antes no se movía:
    1. Respuesta al tocar botones y tallas (resorte).
    2. Entrada de la ficha del producto: foto principal y columna de compra en cascada.
    3. Fotos de la galería que respiran al deslizar.
    4. Talla elegida y precio que reaccionan.
    5. Pestañas que se abren con suavidad.
    6. Carrito que rebota cuando se agrega algo.
    7. Bloques de abajo (confianza, pie de página) que entran al hacer scroll.
    8. Foto de la página de contraseña que se descubre.
  Si el usuario pidió menos movimiento, o Motion no carga, no se anima nada y todo queda visible.
*/
(function () {
  'use strict';

  var root = document.documentElement;

  function ready() {
    window.__igMuiReady = true;
    root.classList.remove('ig-mui');
  }

  var M = window.Motion;
  if (!M || !M.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    ready();
    return;
  }

  var animate = M.animate;
  var inView = M.inView;
  var stagger = M.stagger;

  var EASE = [0.22, 1, 0.36, 1];
  var SPRING = { type: 'spring', stiffness: 520, damping: 32 };
  var POP = { type: 'spring', bounce: 0.45, visualDuration: 0.35 };
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function shown(el) { return el.getClientRects().length > 0; }
  /* Lo que se oculta al cargar para animarlo. Si el navegador no dibuja cuadros (pestaña en
     segundo plano, robots), a los 3 s se muestra igual, sin animación. */
  var pending = [];
  function hide(el, prop, value) { el.style[prop] = value; pending.push([el, prop]); }
  setTimeout(function () {
    pending.forEach(function (p) {
      var el = p[0];
      if (el.getAnimations && el.getAnimations().length) return;
      if (p[1] === 'opacity' && el.style.opacity === '0') el.style.opacity = '';
      if (p[1] === 'clipPath' && el.style.clipPath) el.style.clipPath = '';
    });
  }, 3000);

  function clearTransform(els) {
    (els.length === undefined ? [els] : els).forEach(function (el) { el.style.transform = ''; });
  }

  /* ---------- 1. Tocar: se hunde un poco y vuelve con resorte (delegado, sirve para lo que se re-pinte) ---------- */
  var PRESSABLE = [
    '.button', '.ig-form__submit', '.product-form__submit', '.ig-sg-open', '.igs__cell',
    '.ig-spot__toggle button', '.product-form__input input[type="radio"] + label', '.header__icon',
    '.ig-sg__unit button', '.ig-sg [data-ig-sg-unit]', '.ig-gal__thumb', '.ig-gal__nav'
  ].join(',');

  document.addEventListener('pointerdown', function (e) {
    if (e.button !== 0) return;
    var el = e.target.closest(PRESSABLE);
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return;
    animate(el, { scale: 0.95 }, SPRING);
    function release() {
      window.removeEventListener('pointerup', release);
      window.removeEventListener('pointercancel', release);
      animate(el, { scale: 1 }, SPRING).then(function () { clearTransform(el); });
    }
    window.addEventListener('pointerup', release);
    window.addEventListener('pointercancel', release);
  }, { passive: true });

  /* ---------- 2. Ficha del producto: entrada ---------- */
  var info = $('.product__info-container');
  if (info) {
    var kids = $$(':scope > *', info).filter(shown);
    kids.forEach(function (k) { hide(k, 'opacity', '0'); });
    animate(kids, { opacity: [0, 1], transform: ['translateY(18px)', 'translateY(0px)'] }, {
      duration: 0.6, ease: EASE, delay: stagger(0.045, { startDelay: 0.08 })
    }).then(function () { clearTransform(kids); });

    var first = $('.product__media-item.is-active img') || $('.product__media-item img');
    if (first) animate(first, { opacity: [0, 1], scale: [1.06, 1] }, { duration: 1, ease: EASE });
  }

  /* ---------- 3. Galería: cada foto respira al entrar (deslizando en el teléfono o con las flechas) ---------- */
  var list = $('.product__media-list');
  if (list && inView) {
    var firstItem = true;
    inView($$('.product__media-item', list), function (item) {
      var img = $('img', item);
      if (img && !firstItem) animate(img, { scale: [1.05, 1] }, { duration: 0.7, ease: EASE });
      firstItem = false;
      return function () {};
    }, { root: list.scrollWidth > list.clientWidth ? list : undefined, amount: 0.6 });
  }

  /* Miniaturas: se acercan un poco al pasar el mouse */
  if (fine) {
    document.addEventListener('pointerover', function (e) {
      var t = e.target.closest('.thumbnail-list__item');
      if (!t || t.contains(e.relatedTarget)) return;
      animate(t, { scale: 1.05 }, SPRING);
    });
    document.addEventListener('pointerout', function (e) {
      var t = e.target.closest('.thumbnail-list__item');
      if (!t || t.contains(e.relatedTarget)) return;
      animate(t, { scale: 1 }, SPRING).then(function () { clearTransform(t); });
    });
  }

  /* ---------- 4. Talla elegida: brinco corto; el precio se refresca ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.product-form__input input[type="radio"]')) return;
    var label = input.id && document.querySelector('label[for="' + input.id + '"]');
    if (label) animate(label, { scale: [0.9, 1] }, POP).then(function () { clearTransform(label); });
    setTimeout(function () {
      var price = $('.product__info-container .price');
      if (price) animate(price, { opacity: [0.35, 1], transform: ['translateY(4px)', 'translateY(0px)'] }, { duration: 0.4, ease: EASE })
        .then(function () { clearTransform(price); });
    }, 220);
  });

  /* ---------- 5. Pestañas y preguntas: el contenido baja con suavidad ---------- */
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    if (!d.closest('.accordion, .ig-faq, .product__accordion')) return;
    var body = $$(':scope > :not(summary)', d);
    if (!body.length) return;
    animate(body, { opacity: [0, 1], transform: ['translateY(-8px)', 'translateY(0px)'] }, { duration: 0.35, ease: EASE })
      .then(function () { clearTransform(body); });
  }, true);

  /* ---------- 6. Carrito: rebota cuando cambia el contador ---------- */
  var cart = document.getElementById('cart-icon-bubble');
  if (cart && window.MutationObserver) {
    var lastBounce = 0;
    new MutationObserver(function () {
      var now = Date.now();
      if (now - lastBounce < 600) return;
      lastBounce = now;
      animate(cart, { scale: [1, 1.28, 0.94, 1], rotate: [0, -10, 6, 0] }, { duration: 0.6, ease: 'easeOut' })
        .then(function () { clearTransform(cart); });
      var atc = $('.product-form__submit');
      if (atc) animate(atc, { scale: [1, 1.04, 1] }, { duration: 0.45, ease: 'easeOut' }).then(function () { clearTransform(atc); });
    }).observe(cart, { childList: true, subtree: true, characterData: true });
  }

  /* ---------- 7. Bloques de abajo: entran al hacer scroll (solo lo que está fuera de pantalla al cargar) ---------- */
  if (inView) {
    var below = function (el) { return el.getBoundingClientRect().top > window.innerHeight * 0.9; };
    var groups = [
      { sel: '.ig-trust', kids: ':scope > li' },
      { sel: '.footer__blocks-wrapper', kids: ':scope > .footer-block' },
      { sel: '.footer__content-bottom', kids: null }
    ];
    groups.forEach(function (g) {
      $$(g.sel).forEach(function (wrap) {
        if (!shown(wrap) || !below(wrap)) return;
        var items = g.kids ? $$(g.kids, wrap) : [wrap];
        if (!items.length) return;
        items.forEach(function (it) { it.style.opacity = '0'; });
        inView(wrap, function () {
          animate(items, { opacity: [0, 1], transform: ['translateY(20px)', 'translateY(0px)'] }, {
            duration: 0.55, ease: EASE, delay: stagger(0.07)
          }).then(function () { clearTransform(items); });
        }, { amount: 0.25 });
      });
    });
  }

  /* ---------- 8. Página de contraseña: la foto se descubre de arriba hacia abajo ---------- */
  var photo = $('.ig-pw__photo');
  if (photo) {
    hide(photo, 'clipPath', 'inset(0% 0% 100% 0%)');
    animate(photo, { clipPath: ['inset(0% 0% 100% 0%)', 'inset(0% 0% 0% 0%)'] }, { duration: 1.1, ease: EASE, delay: 0.15 })
      .then(function () { photo.style.clipPath = ''; });
    var pimg = $('img', photo);
    if (pimg) animate(pimg, { scale: [1.12, 1] }, { duration: 1.8, ease: EASE, delay: 0.15 });
    var cap = $('.ig-pw__caption', photo);
    if (cap) hide(cap, 'opacity', '0');
    if (cap) animate(cap, { opacity: [0, 1], transform: ['translateY(10px)', 'translateY(0px)'] }, { duration: 0.6, ease: EASE, delay: 0.9 });
  }

  ready();
})();
